import React, { useState, useEffect } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Chip,
  Avatar,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Tabs,
  Tab,
  FormLabel,
  Alert,
  RadioGroup,
  Tooltip,
  Radio,
  Divider,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  FormControlLabel,
  InputAdornment,
  CircularProgress,
  CardHeader
} from '@mui/material';
import {
  Add as AddIcon,
  Home as HomeIcon,
  Assessment as AssessmentIcon,
  Schedule as ScheduleIcon,
  AttachMoney as MoneyIcon, 
  Edit as EditIcon,
  Delete as DeleteIcon,
  Visibility as ViewIcon,
  TrendingUp as TrendingUpIcon,
  CompareArrows as CompareIcon,
  Timeline as TimelineIcon,
  CheckCircle as CheckIcon,
  LocationOn as LocationOnIcon,
  AccountCircle,
  PhoneAndroid,
  BusinessCenter,
  Email 
} from '@mui/icons-material';
import { useDebouncedCallback } from 'use-debounce';
import { qaddressSearch } from '../../service/Address/searchaddress';
import { getOfficeDetails } from '../../service/Office/getOfficeDetails';
import { getpropertySubType } from '../../service/Listings/getpropertyType';
import { getpropertyType } from '../../service/Listings/getpropertyType';
import { getRegions } from '../../service/Address/getRegions';
import { getContactsByCommunicationDetail } from '../../service/Contacts/getContacts'; 

const AppraisalView = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [addressSearchValue, setAddressSearchValue] = useState('');

  const [selectedAppraisal, setSelectedAppraisal] = useState(null);
  const [appraisals, setAppraisals] = useState([]);
  const [searchAddressResults, setSearchAddressResults] = useState([]);
  const [contactResultsMobile, setContactResultsMobile] = useState([]);
  const [contactResultsEmail, setContactResultsEmail] = useState([]);
  const [regions, setRegions] = useState([]);
  const [officeDetails, setOfficeDetails] = useState({});
  const [propertyTypes, setPropertyTypes] = useState([]);
  const [propertySubTypes, setPropertySubTypes] = useState([]);

  const [openDialog, setOpenDialog] = useState(false);
  const [isAddressSelected, setIsAddressSelected] = useState(false);
  const [isSearchingMapbox, setIsSearchingMapbox] = useState(false);
  const [isSearchingMobile, setIsSearchingMobile] = useState(false);
  const [isSearchingEmail, setIsSearchingEmail] = useState(false);

  const [newAppraisal, setNewAppraisal] = useState({
    streetNo: '',
    regionid: '',
    propertyType: '',
    propertySubType: '',
    appraisalDone: 'No',
    appraisalDate: '',
    appraisalValueFrom: '',
    appraisalValueTo: '',
    appraisalValueOpinion: '',
    appraisalNotes: '',
    reasonForSelling: '',
    bedrooms: 0,
    bathrooms: 0,
    carSpace: 0,
    garage: 0,
    carPort: 0,
    landSize: '',
    buildingArea: '',
    hardStand: '',
    trussHeight: '',
    zoneCode: '',
    vendorValueFrom: '',
    vendorValueTo: '',
    clientName: '',
    clientLastName: '',
    clientEmail: '',
    clientPhone: '',
    addressSearchValue: ''
  });

  const [selectedContact, setSelectedContact] = useState(null);

  const getStatusColor = (status) => {
    switch (status) {
      case 'completed': return 'success';
      case 'in_progress': return 'warning';
      case 'scheduled': return 'info';
      default: return 'default';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'completed': return <CheckIcon />;
      case 'in_progress': return <TrendingUpIcon />;
      case 'scheduled': return <ScheduleIcon />;
      default: return <AssessmentIcon />;
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [
          propertyTypeResponse,
          regionsResponse,
          officeDetailsResponse,
        ] = await Promise.all([
          getpropertyType(),
          getRegions(),
          getOfficeDetails(),
        ]);
        
        setPropertyTypes(propertyTypeResponse.data || []);
        setRegions(regionsResponse.data || []);
        setOfficeDetails(officeDetailsResponse.data || {});
      } catch (error) {
        console.error('Error fetching initial data:', error);
      }
    };
    
    fetchData();
  }, []); 

  useEffect(() => {
    const fetchSubTypes = async () => {
      if (!newAppraisal?.propertyType) {
        setPropertySubTypes([]);
        return;
      }
      try {
      
        
        if (newAppraisal?.propertyType) {     
          const response = await getpropertySubType(newAppraisal?.propertyType);
          setPropertySubTypes(response.data || []);
        } else {
          setPropertySubTypes([]);
        }
      } catch (error) {
        console.error('Error fetching property subtypes:', error);
        setPropertySubTypes([]);
      }
    };

    fetchSubTypes();
  }, [newAppraisal?.propertyType, propertyTypes]);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleAddAppraisal = () => {
    setOpenDialog(true);
    setSelectedAppraisal(null);
    setNewAppraisal({
      streetNo: '',
      regionid: '',
      propertyType: '',
      propertySubType: '',
      appraisalDone: 'No',
      appraisalDate: '',
      appraisalValueFrom: '',
      appraisalValueTo: '',
      appraisalValueOpinion: '',
      appraisalNotes: '',
      reasonForSelling: '',
      bedrooms: 0,
      bathrooms: 0,
      carSpace: 0,
      garage: 0,
      carPort: 0,
      landSize: '',
      buildingArea: '',
      hardStand: '',
      trussHeight: '',
      zoneCode: '',
      vendorValueFrom: '',
      vendorValueTo: '',
      clientName: '',
      clientLastName: '',
      clientEmail: '',
      clientPhone: '',
      addressSearchValue: ''
    });
    setIsAddressSelected(false);
    setAddressSearchValue('');
    setSearchAddressResults([]);
  };

  const handleEditAppraisal = (appraisal) => {
    setSelectedAppraisal(appraisal);
    setNewAppraisal(appraisal);
    setIsAddressSelected(!!appraisal.fullAddress);
    setAddressSearchValue(appraisal.fullAddress || '');
    setOpenDialog(true);
  };

  const searchAddress = useDebouncedCallback(async (searchAddressText) => {
    setIsSearchingMapbox(true);
    if ((searchAddressText && searchAddressText.length > 3)) {
      let queryString = `q=${searchAddressText}`;
      let countryCode = officeDetails.countryId === 152 ? 'NZ' : 'AU';

      if (officeDetails.latitude && officeDetails.longitude) {
        queryString = `${queryString}&proximity=${officeDetails.longitude},${officeDetails.latitude}&country=${countryCode}&limit=5`;
      } else {
        queryString = `${queryString}&country=${countryCode}&limit=5`;
      }

      try {
        const addressResults = await qaddressSearch(queryString);
        if (addressResults.data && addressResults.data.length > 0) {
          setSearchAddressResults(addressResults.data);
        } else {
          setSearchAddressResults([]);
        }
      } catch (error) {
        console.error('Error searching addresses:', error);
        setSearchAddressResults([]);
      }
    }
    setIsSearchingMapbox(false);
  }, 500);

  const searchContacts = useDebouncedCallback(async (mobile, email, source) => {
      if (source === 'mobile') {
        setIsSearchingMobile(true);
      } else if (source === 'email') {
        setIsSearchingEmail(true);
      }

      try {
        const contacts = await getContactsByCommunicationDetail(mobile, email, source);
        if (contacts.data && contacts.data.length > 0) {
          if (source === 'email') {
            setContactResultsEmail(contacts.data);
          } else {
            setContactResultsMobile(contacts.data);
          }
        } else {
          setContactResultsMobile([]);
          setContactResultsEmail([]);
        }
      } catch (error) { 
        setContactResultsMobile([]);
        setContactResultsEmail([]);
      } finally {
        if (source === 'mobile') {
          setIsSearchingMobile(false);
        } else if (source === 'email') {
          setIsSearchingEmail(false);
        }
      }
  
  }, 500);


  const handleSaveAppraisal = async () => {
    try {
      if (selectedAppraisal) {
        // Update existing appraisal
        const response = await fetch(`/api/appraisals/${selectedAppraisal.id}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(newAppraisal),
        });
        
        if (response.ok) {
          const updatedAppraisal = await response.json();
          setAppraisals(appraisals.map(app => 
            app.id === selectedAppraisal.id ? updatedAppraisal : app
          ));
        }
      } else {

    
        const newAppraisalData = {
          ...newAppraisal
        };
        
        setAppraisals([...appraisals, newAppraisalData]);
      }
      setOpenDialog(false);
    } catch (error) {
      console.error('Error saving appraisal:', error);
      // Handle error (show notification, etc.)
    }
  };

  const handleDeleteAppraisal = (id) => {
    setAppraisals(appraisals.filter(app => app.id !== id));
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: 'AUD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  };

  const getUpcomingAppraisals = () => {
    const today = new Date().toISOString().split('T')[0];
    return appraisals.filter(app => 
      app.appraisalDate >= today && app.status === 'scheduled'
    ).length;
  };

  const getCompletedThisMonth = () => {
    const currentMonth = new Date().getMonth();
    const currentYear = new Date().getFullYear();
    return appraisals.filter(app => {
      const appraisalDate = new Date(app.appraisalDate);
      return appraisalDate.getMonth() === currentMonth && 
             appraisalDate.getFullYear() === currentYear &&
             app.status === 'completed';
    }).length;
  };

  const getTotalValue = () => {
    return appraisals
      .filter(app => app.status === 'completed')
      .reduce((total, app) => total + (app.estimatedValue || 0), 0);
  };

  const handleAddressSelect = (selectedAddress) => {
    setNewAppraisal(prev => ({
      ...prev,
      Stateid: selectedAddress.stateId,
      Suburbid: selectedAddress.suburbId,
      streetName: selectedAddress.streetName,
      fullAddress: selectedAddress.fullAddress,
      postcode: selectedAddress.postCode,
      suburb: selectedAddress.suburb || '',
    }));
    setIsAddressSelected(true);
    setAddressSearchValue(selectedAddress.fullAddress);
    setSearchAddressResults([]);
  };

  const handleAddressChange = () => {
    setIsAddressSelected(false);
    setAddressSearchValue('');
    setSearchAddressResults([]);
    setNewAppraisal(prev => ({
      ...prev,
      Stateid: '',
      Suburbid: '',
      streetName: '',
      fullAddress: '',
      postcode: '',
      suburb:  '',
    }));
  };

  const handleContactSelect = (contact) => {
    console.log(contact);
    setNewAppraisal(prev => ({
      ...prev,
      clientName: contact.firstname?.trim() || '',
      clientLastName: contact.lastname?.trim() || '',
      clientPhone: contact.mobile?.trim() || '',
      clientEmail: contact.email?.trim() || '',
      contactid: contact.contactid || ''
    }));
    setSelectedContact(contact);
    setContactResultsMobile([]);
    setContactResultsEmail([]);
  };

  const handleRemoveContact = () => {
    setSelectedContact(null);
    setNewAppraisal(prev => ({
      ...prev,
      clientName: '',
      clientLastName: '',
      clientPhone: '',
      clientEmail: '',
      contactid:''
    }));
  };

  const TabPanel = ({ children, value, index }) => (
    <div hidden={value !== index}>
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );

  return (
    <Box sx={{ p: 3, backgroundColor: '#f5f5f5', minHeight: '100vh' }}>
      {/* Header */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 'bold', color: '#1976d2' }}>
          Property Appraisals
        </Typography>
        <Typography variant="subtitle1" color="text.secondary">
          Manage property valuations, client relationships, and market comparisons
        </Typography>
      </Box>

      {/* Statistics Cards */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ background: 'linear-gradient(135deg, #1976d2, #42a5f5)' }}>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', color: 'white' }}>
                <ScheduleIcon sx={{ fontSize: 40, mr: 2 }} />
                <Box>
                  <Typography variant="h4" component="div" sx={{ fontWeight: 'bold' }}>
                    {getUpcomingAppraisals()}
                  </Typography>
                  <Typography variant="body2">
                    Upcoming Appraisals
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ background: 'linear-gradient(135deg, #388e3c, #66bb6a)' }}>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', color: 'white' }}>
                <CheckIcon sx={{ fontSize: 40, mr: 2 }} />
                <Box>
                  <Typography variant="h4" component="div" sx={{ fontWeight: 'bold' }}>
                    {getCompletedThisMonth()}
                  </Typography>
                  <Typography variant="body2">
                    Completed This Month
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ background: 'linear-gradient(135deg, #f57c00, #ffb74d)' }}>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', color: 'white' }}>
                <MoneyIcon sx={{ fontSize: 40, mr: 2 }} />
                <Box>
                  <Typography variant="h4" component="div" sx={{ fontWeight: 'bold' }}>
                    {formatCurrency(getTotalValue() / 1000000)}M
                  </Typography>
                  <Typography variant="body2">
                    Total Portfolio Value
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ background: 'linear-gradient(135deg, #7b1fa2, #ba68c8)' }}>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', color: 'white' }}>
                <TrendingUpIcon sx={{ fontSize: 40, mr: 2 }} />
                <Box>
                  <Typography variant="h4" component="div" sx={{ fontWeight: 'bold' }}>
                    {appraisals.length}
                  </Typography>
                  <Typography variant="body2">
                    Total Appraisals
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Main Content */}
      <Card>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={activeTab} onChange={handleTabChange}>
            <Tab label="All Appraisals" icon={<AssessmentIcon />} />
            <Tab label="Market Analysis" icon={<CompareIcon />} />
            <Tab label="Pipeline" icon={<TimelineIcon />} />
          </Tabs>
        </Box>

        <TabPanel value={activeTab} index={0}>
          <Box sx={{ p: 3 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
              <Typography variant="h6">Property Appraisals</Typography>
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={handleAddAppraisal}
                sx={{ borderRadius: 2 }}
              >
                New Appraisal
              </Button>
            </Box>

            <TableContainer component={Paper} sx={{ boxShadow: 2 }}>
              <Table>
                <TableHead sx={{ backgroundColor: '#f8f9fa' }}>
                  <TableRow>
                    <TableCell>Property</TableCell>
                    <TableCell>Client</TableCell>
                    <TableCell>Date</TableCell>
                    <TableCell>Value</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Agent</TableCell>
                    <TableCell align="center">Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {appraisals.map((appraisal) => (
                    <TableRow key={appraisal.id} hover>
                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          <Avatar sx={{ mr: 2, bgcolor: '#1976d2' }}>
                            <HomeIcon />
                          </Avatar>
                          <Box>
                            <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                              {appraisal.propertyAddress}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                              {appraisal.propertyType} • {appraisal.bedrooms}BR {appraisal.bathrooms}BA
                            </Typography>
                          </Box>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box>
                          <Typography variant="subtitle2">{appraisal.clientName}</Typography>
                          <Typography variant="caption" color="text.secondary">
                            {appraisal.clientPhone}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>{new Date(appraisal.appraisalDate).toLocaleDateString()}</TableCell>
                      <TableCell>
                        <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#388e3c' }}>
                          {appraisal.estimatedValue ? formatCurrency(appraisal.estimatedValue) : 'TBD'}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Chip
                          icon={getStatusIcon(appraisal.status)}
                          label={appraisal.status.replace('_', ' ').toUpperCase()}
                          color={getStatusColor(appraisal.status)}
                          size="small"
                        />
                      </TableCell>
                      <TableCell>{appraisal.agent}</TableCell>
                      <TableCell align="center">
                        <Tooltip title="View Details">
                          <IconButton color="primary" size="small">
                            <ViewIcon />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Edit">
                          <IconButton color="primary" size="small" onClick={() => handleEditAppraisal(appraisal)}>
                            <EditIcon />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Delete">
                          <IconButton color="error" size="small" onClick={() => handleDeleteAppraisal(appraisal.id)}>
                            <DeleteIcon />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </TabPanel>

        <TabPanel value={activeTab} index={1}>
          <Box sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>Market Comparison Analysis</Typography>
            <Grid container spacing={3}>
              {appraisals.filter(app => app.marketComps.length > 0).map((appraisal) => (
                <Grid item xs={12} md={6} key={appraisal.id}>
                  <Card sx={{ boxShadow: 2 }}>
                    <CardContent>
                      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2 }}>
                        {appraisal.propertyAddress}
                      </Typography>
                      <Typography variant="h6" color="primary" sx={{ mb: 2 }}>
                        Est. Value: {formatCurrency(appraisal.estimatedValue)}
                      </Typography>
                      <Typography variant="subtitle2" sx={{ mb: 2 }}>Recent Comparables:</Typography>
                      <List dense>
                        {appraisal.marketComps.map((comp, index) => (
                          <ListItem key={index}>
                            <ListItemIcon>
                              <CompareIcon color="primary" />
                            </ListItemIcon>
                            <ListItemText
                              primary={comp.address}
                              secondary={`Sold: ${formatCurrency(comp.soldPrice)} on ${new Date(comp.soldDate).toLocaleDateString()}`}
                            />
                          </ListItem>
                        ))}
                      </List>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box>
        </TabPanel>

        <TabPanel value={activeTab} index={2}>
          <Box sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>Appraisal Pipeline</Typography>
            <Grid container spacing={3}>
              {['scheduled', 'in_progress', 'completed'].map((status) => (
                <Grid item xs={12} md={4} key={status}>
                  <Card sx={{ boxShadow: 2 }}>
                    <CardContent>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                        {getStatusIcon(status)}
                        <Typography variant="h6" sx={{ ml: 1, textTransform: 'capitalize' }}>
                          {status.replace('_', ' ')}
                        </Typography>
                        <Chip
                          label={appraisals.filter(app => app.status === status).length}
                          color={getStatusColor(status)}
                          size="small"
                          sx={{ ml: 'auto' }}
                        />
                      </Box>
                      <List dense>
                        {appraisals.filter(app => app.status === status).map((appraisal) => (
                          <ListItem key={appraisal.id} sx={{ px: 0 }}>
                            <ListItemText
                              primary={appraisal.clientName}
                              secondary={appraisal.propertyAddress}
                            />
                          </ListItem>
                        ))}
                      </List>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box>
        </TabPanel>
      </Card>

      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="lg" fullWidth>
      <DialogTitle sx={{ pb: 1 }}>
        <Typography variant="h5" component="div">
          {selectedAppraisal ? 'Edit Appraisal' : 'New Appraisal'}
        </Typography>
      </DialogTitle>
      
      <DialogContent sx={{ pb: 2 }}>
        <Box sx={{ mt: 2 }}>
          
          {/* Address Section */}
          <Box sx={{ mb: 3 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={3}>
                <TextField
                  fullWidth
                  label="Street No"
                  value={newAppraisal.streetNo}
                  onChange={(e) => setNewAppraisal({ ...newAppraisal, streetNo: e.target.value })}
                />
              </Grid>
              <Grid item xs={12}>
                  {!isAddressSelected ? (
                    <>
                      <TextField
                        label="Street Name, Suburb, State, Postcode"
                        onChange={(e) => {
                          setAddressSearchValue(e.target.value);
                          setNewAppraisal({ ...newAppraisal, addressSearchValue: e.target.value });
                          searchAddress(e.target.value);
                        }}
                        value={addressSearchValue}
                        fullWidth
                        placeholder="Start typing to search for an address..."
                      />

                      {isSearchingMapbox && (
                        <Grid container alignItems="center" sx={{ padding: 2 }}>
                          <CircularProgress size={20} sx={{ marginRight: 1 }} />
                          <Typography sx={{ color: '#555' }}>Searching addresses…</Typography>
                        </Grid>
                      )}

                      {/* Address Search Results */}
                      {searchAddressResults.length > 0 && !isSearchingMapbox && (
                        <Card sx={{ backgroundColor: '#f5f5f5', mt: 1 }}>
                          <CardContent>
                            {searchAddressResults.map((item, index) => (
                              <Button
                                key={index}
                                startIcon={<LocationOnIcon />}
                                onClick={() => handleAddressSelect(item)}
                                sx={{ mb: 1, textTransform: 'none' }}
                                fullWidth
                                variant="outlined"
                              >
                                {item.fullAddress}
                              </Button>
                            ))}
                          </CardContent>
                        </Card>
                      )}
                    </>
                  ) : (
                    <Card sx={{ borderRadius: 1, mt: 2, backgroundColor: '#f5f5f5' }}>
                      <CardHeader
                        avatar={<LocationOnIcon />}
                        title={<Typography variant="body1" sx={{ fontSize: 16 }}>Selected Address</Typography>}
                      />
                      <CardContent>
                        <Typography sx={{ fontSize: 16, mb: 1 }}>
                          {newAppraisal.fullAddress}
                        </Typography>
                        <Button onClick={handleAddressChange}>
                          Change Address
                        </Button>
                      </CardContent>
                    </Card>
                  )}
                </Grid>
              <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <InputLabel>Region</InputLabel>
                    <Select
                      value={newAppraisal.regionid}
                      onChange={(e) => setNewAppraisal({ ...newAppraisal, regionid: e.target.value })}
                      label="Region"
                    >
                      {regions.map((region) => (
                        <MenuItem key={region.regionid || index} value={region.regionid}>
                          {region.regionName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
            </Grid>
          </Box>

          <Divider sx={{ my: 3 }} />

          {/* Property Type Section */}
          <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel>Property Type</InputLabel>
                  <Select
                    value={newAppraisal.propertyType}
                    onChange={(e) => setNewAppraisal({ 
                      ...newAppraisal, 
                      propertyType: e.target.value,
                      propertySubType: '' 
                    })}
                    label="Property Type"
                  >
                    {propertyTypes.map((type, index) => {
                    const typeId = type.type || index; // what you want as the value
                    const typeName = type.title; 
                    return (
                      <MenuItem key={typeId} value={typeId}>
                        {typeName}
                      </MenuItem>
                    );
                  })}
                  
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel>Property Sub-Type</InputLabel>
                  <Select
                    value={newAppraisal.propertySubType}
                    onChange={(e) => setNewAppraisal({ ...newAppraisal, propertySubType: e.target.value })}
                    label="Property Sub-Type"
                    disabled={!newAppraisal.propertyType}
                  >
                    {propertySubTypes.map((subType, index) => {          
                      const subTypeId = subType.id || subType.propertySubTypeId || index;
                      const subTypeName = subType.name || subType.propertySubTypeName || subType.subTypeName || subType.title;
                      
                      return (
                        <MenuItem key={subTypeId} value={subTypeName}>
                          {subTypeName}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>

          <Divider sx={{ my: 3 }} />

          {/* Appraisal Details Section */}
          <Typography variant="h6" sx={{ mb: 2, color: 'primary.main' }}>
            Appraisal Details
          </Typography>
          
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} sm={6}>
              <FormLabel component="legend">Appraisal Done</FormLabel>
              <RadioGroup
                row
                value={newAppraisal.appraisalDone}
                onChange={(e) => setNewAppraisal({ ...newAppraisal, appraisalDone: e.target.value })}
              >
                <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="No" control={<Radio />} label="No" />
              </RadioGroup>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Appraisal Date"
                type="date"
                value={newAppraisal.appraisalDate}
                onChange={(e) => setNewAppraisal({ ...newAppraisal, appraisalDate: e.target.value })}
                slotProps={{ shrink: true }}
              />
            </Grid>
          </Grid>

          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Appraisal Value From"
                type="number"
                value={newAppraisal.appraisalValueFrom}
                onChange={(e) => setNewAppraisal({ ...newAppraisal, appraisalValueFrom: e.target.value })}
                slotProps={{
                  input: {
                    startAdornment: <InputAdornment position="start">$</InputAdornment>,
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Appraisal Value To"
                type="number"
                value={newAppraisal.appraisalValueTo}
                onChange={(e) => setNewAppraisal({ ...newAppraisal, appraisalValueTo: e.target.value })}
                slotProps={{
                  input: {
                    startAdornment: <InputAdornment position="start">$</InputAdornment>,
                  },
                }}
              />
            </Grid>
          </Grid>

          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Appraisal Value Opinion"
                value={newAppraisal.appraisalValueOpinion}
                onChange={(e) => setNewAppraisal({ ...newAppraisal, appraisalValueOpinion: e.target.value })}
              />
            </Grid>
          </Grid>

          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Appraisal Notes"
                multiline
                rows={3}
                value={newAppraisal.appraisalNotes}
                onChange={(e) => setNewAppraisal({ ...newAppraisal, appraisalNotes: e.target.value })}
              />
            </Grid>
          </Grid>

          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Reason For Selling"
                multiline
                rows={2}
                value={newAppraisal.reasonForSelling}
                onChange={(e) => setNewAppraisal({ ...newAppraisal, reasonForSelling: e.target.value })}
              />
            </Grid>
          </Grid>

          <Divider sx={{ my: 3 }} />

          {/* Property Features Section */}
          <Typography variant="h6" sx={{ mb: 2, color: 'primary.main' }}>
            Property Features
          </Typography>
          
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={6} sm={3}>
              <TextField
                fullWidth
                label="Bedrooms"
                type="number"
                value={newAppraisal.bedrooms}
                onChange={(e) => setNewAppraisal({ ...newAppraisal, bedrooms: parseInt(e.target.value) || 0 })}
                slotProps={{ min: 0 }}
              />
            </Grid>
            <Grid item xs={6} sm={3}>
              <TextField
                fullWidth
                label="Bathrooms"
                type="number"
                value={newAppraisal.bathrooms}
                onChange={(e) => setNewAppraisal({ ...newAppraisal, bathrooms: parseInt(e.target.value) || 0 })}
                slotProps={{ min: 0 }}
              />
            </Grid>
            <Grid item xs={6} sm={3}>
              <TextField
                fullWidth
                label="Car Space"
                type="number"
                value={newAppraisal.carSpace}
                onChange={(e) => setNewAppraisal({ ...newAppraisal, carSpace: parseInt(e.target.value) || 0 })}
                slotProps={{ min: 0 }}
              />
            </Grid>
            <Grid item xs={6} sm={3}>
              <TextField
                fullWidth
                label="Garage"
                type="number"
                value={newAppraisal.garage}
                onChange={(e) => setNewAppraisal({ ...newAppraisal, garage: parseInt(e.target.value) || 0 })}
                slotProps={{ min: 0 }}
              />
            </Grid>
          </Grid>

          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Carport"
                type="number"
                value={newAppraisal.carPort}
                onChange={(e) => setNewAppraisal({ ...newAppraisal, carPort: parseInt(e.target.value) || 0 })}
                slotProps={{ min: 0 }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Land Size"
                type="number"
                value={newAppraisal.landSize}
                onChange={(e) => setNewAppraisal({ ...newAppraisal, landSize: e.target.value })}
                slotProps={{
                  input: {
                    endAdornment: <InputAdornment position="start">m²</InputAdornment>,
                  },
                }}
              />
            </Grid>
          </Grid>

          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Building Area"
                type="number"
                value={newAppraisal.buildingArea}
                onChange={(e) => setNewAppraisal({ ...newAppraisal, buildingArea: e.target.value })}
                slotProps={{
                  input: {
                    endAdornment: <InputAdornment position="start">m²</InputAdornment>,
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Hardstand"
                type="number"
                value={newAppraisal.hardStand}
                onChange={(e) => setNewAppraisal({ ...newAppraisal, hardStand: e.target.value })}
                slotProps={{
                  input: {
                    endAdornment: <InputAdornment position="start">m²</InputAdornment>,
                  },
                }}
              />
            </Grid>
          </Grid>

          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Truss Height"
                type="number"
                value={newAppraisal.trussHeight}
                onChange={(e) => setNewAppraisal({ ...newAppraisal, trussHeight: e.target.value })}
                slotProps={{
                  input: {
                    endAdornment: <InputAdornment position="start">m</InputAdornment>,
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Zone Code"
                value={newAppraisal.zoneCode}
                onChange={(e) => setNewAppraisal({ ...newAppraisal, zoneCode: e.target.value })}
              />
            </Grid>
          </Grid>

          <Divider sx={{ my: 3 }} />

          {/* Vendor's Market Value Opinion Section */}
          <Typography variant="h6" sx={{ mb: 2, color: 'primary.main' }}>
            Vendor's Market Value Opinion
          </Typography>
          
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="From"
                type="number"
                value={newAppraisal.vendorValueFrom}
                onChange={(e) => setNewAppraisal({ ...newAppraisal, vendorValueFrom: e.target.value })}
                slotProps={{
                  input: {
                  startAdornment: <InputAdornment position="start">$</InputAdornment>
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="To"
                type="number"
                value={newAppraisal.vendorValueTo}
                onChange={(e) => setNewAppraisal({ ...newAppraisal, vendorValueTo: e.target.value })}
                slotProps={{
                  input: {
                  startAdornment: <InputAdornment position="start">$</InputAdornment>
                  },
                }}
              />
            </Grid>
          </Grid>

          <Divider sx={{ my: 3 }} />

          {/* Client Information Section */}
          <Typography variant="h6" sx={{ mb: 2, color: 'primary.main' }}>
            Client Information
          </Typography>
          
          <Grid container spacing={2}>  
            {selectedContact ? (
              // Show selected contact card
              <Grid item xs={12}>
                <Card sx={{ borderRadius: 2, boxShadow: 3, bgcolor: '#e8f5e8', border: '2px solid #4caf50' }}>
                  <CardContent>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                      <Box>
                        <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#2e7d32', mb: 1 }}>
                          Selected Contact
                        </Typography>
                        <Typography variant="h5" sx={{ fontWeight: '600', mb: 1 }}>
                          {selectedContact.firstname} {selectedContact.lastname}
                        </Typography>
                        {selectedContact.mobile && (
                          <Typography variant="body1" sx={{ color: '#555', mb: 0.5 }}>
                            Mobile: {selectedContact.mobile}
                          </Typography>
                        )}
                        {selectedContact.email && (
                          <Typography variant="body1" sx={{ color: '#555', mb: 0.5 }}>
                            Email: {selectedContact.email}
                          </Typography>
                        )}
                        {selectedContact.workphone && (
                          <Typography variant="body1" sx={{ color: '#555', mb: 0.5 }}>
                            Work: {selectedContact.workphone}
                          </Typography>
                        )}
                        {selectedContact.homephone && (
                          <Typography variant="body1" sx={{ color: '#555', mb: 0.5 }}>
                             Home: {selectedContact.homephone}
                          </Typography>
                        )}
                        {selectedContact.agentfirstname && selectedContact.agentlastname && (
                          <Typography variant="body2" sx={{ color: '#666', mt: 1, fontStyle: 'italic' }}>
                            Agent: {selectedContact.agentfirstname} {selectedContact.agentlastname}
                          </Typography>
                        )}
                      </Box>
                      <Button
                        onClick={handleRemoveContact}
                        variant="outlined"
                        color="error"
                        size="small"
                        sx={{ mt: 1 }}
                      >
                        Remove Contact
                      </Button>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            ) : (
              // Show search fields when no contact is selected
              <>
                {/* Mobile Input */}
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Mobile"
                    value={newAppraisal.clientPhone}
                    onChange={(e) => {
                      setNewAppraisal({ ...newAppraisal, clientPhone: e.target.value });
                      searchContacts(e.target.value, '', 'mobile');
                    }}
                    variant="outlined"
                    fullWidth
                  />
                  {newAppraisal.clientPhone && newAppraisal.clientPhone.length > 3 && (
                    <Box sx={{ mt: 1 }}>
                      {isSearchingMobile && (
                        <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                          <CircularProgress size={24} />
                          <Typography variant="body2" sx={{ mt: 1, color: '#555' }}>Searching contacts…</Typography>
                        </Box>
                      )}
                      {contactResultsMobile.length > 0 && !isSearchingMobile && (
                        <Card sx={{ borderRadius: 2, boxShadow: 3, bgcolor: '#f5f5f5', mt: 1 }}>
                          <CardContent>
                            {contactResultsMobile.map((item) => (
                              <Button
                                key={`${item.contactid}-${item.firstname}`}
                                onClick={() => handleContactSelect(item)}
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                  width: '100%',
                                  py: 1.5,
                                  px: 2,
                                  mb: 1.5,
                                  bgcolor: '#f9f9f9',
                                  borderRadius: 2.5,
                                  boxShadow: 1,
                                  textTransform: 'none',
                                  color: 'inherit',
                                  '&:hover': { bgcolor: '#e0e0e0' }
                                }}
                              >
                                 <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                <Typography variant="h6" sx={{ fontWeight: '400' }}>
                                  <AccountCircle sx={{ verticalAlign: 'middle', mr: 0.5 }} />
                                  {item.firstname} {item.lastname}
                                </Typography>
                                {item.mobile && (
                                  <Typography variant="body2" sx={{ color: '#555', mt: 0.5 }}>
                                    <PhoneAndroid sx={{ verticalAlign: 'middle', mr: 0.5, fontSize: 16 }} />
                                    {item.mobile}
                                  </Typography>
                                )}
                                {item.email && (
                                  <Typography variant="body2" sx={{ color: '#555', mt: 0.5 }}>
                                    <Email sx={{ verticalAlign: 'middle', mr: 0.5, fontSize: 16 }} />
                                    {item.email}
                                    {item.emailVerified === 1 && (
                                      <AccountCircle sx={{ verticalAlign: 'middle', ml: 0.5, color: 'green' }} />
                                    )}
                                  </Typography>
                                )}
                                {item.agentfirstname && item.agentlastname && (
                                  <Typography variant="body2" sx={{ color: '#555', mt: 0.5 }}>
                                    <BusinessCenter sx={{ verticalAlign: 'middle', mr: 0.5, fontSize: 16 }} />
                                    {item.agentfirstname} {item.agentlastname}
                                  </Typography>
                                )}
                              </Box>
                              <Box>
                                <Typography
                                  variant="caption"
                                  sx={{
                                    bgcolor:
                                      item.contactstatusid === 1
                                        ? 'green'
                                        : item.contactstatusid === 2
                                          ? 'orange'
                                          : 'red',
                                    color: 'white',
                                    fontWeight: 'bold',
                                    borderRadius: 1,
                                    px: 1.2,
                                    py: 0.5,
                                  }}
                                >
                                  {item.contactstatusid === 1
                                    ? 'Current'
                                    : item.contactstatusid === 2
                                      ? 'Archived'
                                      : 'Deleted'}
                                </Typography>
                              </Box>
                          
                              </Button>
                            ))}
                          </CardContent>
                        </Card>
                      )}
                      {!isSearchingMobile && contactResultsMobile.length === 0 && newAppraisal.clientPhone.length > 3 && (
                        <Card sx={{ borderRadius: 2, boxShadow: 3, bgcolor: '#f5f5f5', mt: 1 }}>
                          <CardContent>
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 2.5 }}>
                              <Typography variant="body1" sx={{ color: '#666', mt: 1.2, textAlign: 'center' }}>
                                No contacts found
                              </Typography>
                            </Box>
                          </CardContent>
                        </Card>
                      )}
                    </Box>
                  )}
                </Grid>

                {/* Email Input */}
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Email"
                    value={newAppraisal.clientEmail}
                    onChange={(e) => {
                      setNewAppraisal({ ...newAppraisal, clientEmail: e.target.value });
                      searchContacts('', e.target.value, 'email');
                    }}
                    variant="outlined"
                    fullWidth
                    type="email"
                  />
                  {newAppraisal.clientEmail && newAppraisal.clientEmail.length > 5 && (
                    <Box sx={{ mt: 1 }}>
                      {isSearchingEmail && (
                        <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                          <CircularProgress size={24} />
                          <Typography variant="body2" sx={{ mt: 1, color: '#555' }}>Searching contacts…</Typography>
                        </Box>
                      )}
                      {contactResultsEmail.length > 0 && !isSearchingEmail && (
                        <Card sx={{ borderRadius: 2, boxShadow: 3, bgcolor: '#f5f5f5', mt: 1 }}>
                          <CardContent>
                            {contactResultsEmail.map((item) => (
                              <Button
                                key={`${item.contactid}-${item.firstname}`}
                                onClick={() => handleContactSelect(item)}
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                  width: '100%',
                                  py: 1.5,
                                  px: 2,
                                  mb: 1.5,
                                  bgcolor: '#f9f9f9',
                                  borderRadius: 2.5,
                                  boxShadow: 1,
                                  textTransform: 'none',
                                  color: 'inherit',
                                  '&:hover': { bgcolor: '#e0e0e0' }
                                }}
                              >
                                 <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                <Typography variant="h6" sx={{ fontWeight: '400' }}>
                                  <AccountCircle sx={{ verticalAlign: 'middle', mr: 0.5 }} />
                                  {item.firstname} {item.lastname}
                                </Typography>
                                {item.mobile && (
                                  <Typography variant="body2" sx={{ color: '#555', mt: 0.5 }}>
                                    <PhoneAndroid sx={{ verticalAlign: 'middle', mr: 0.5, fontSize: 16 }} />
                                    {item.mobile}
                                  </Typography>
                                )}
                                {item.email && (
                                  <Typography variant="body2" sx={{ color: '#555', mt: 0.5 }}>
                                    <Email sx={{ verticalAlign: 'middle', mr: 0.5, fontSize: 16 }} />
                                    {item.email}
                                    {item.emailVerified === 1 && (
                                      <AccountCircle sx={{ verticalAlign: 'middle', ml: 0.5, color: 'green' }} />
                                    )}
                                  </Typography>
                                )}
                                {item.agentfirstname && item.agentlastname && (
                                  <Typography variant="body2" sx={{ color: '#555', mt: 0.5 }}>
                                    <BusinessCenter sx={{ verticalAlign: 'middle', mr: 0.5, fontSize: 16 }} />
                                    {item.agentfirstname} {item.agentlastname}
                                  </Typography>
                                )}
                              </Box>
                              <Box>
                                <Typography
                                  variant="caption"
                                  sx={{
                                    bgcolor:
                                      item.contactstatusid === 1
                                        ? 'green'
                                        : item.contactstatusid === 2
                                          ? 'orange'
                                          : 'red',
                                    color: 'white',
                                    fontWeight: 'bold',
                                    borderRadius: 1,
                                    px: 1.2,
                                    py: 0.5,
                                  }}
                                >
                                  {item.contactstatusid === 1
                                    ? 'Current'
                                    : item.contactstatusid === 2
                                      ? 'Archived'
                                      : 'Deleted'}
                                </Typography>
                              </Box>
                              </Button>
                            ))}
                          </CardContent>
                        </Card>
                      )}
                      {!isSearchingEmail && contactResultsEmail.length === 0 && newAppraisal.clientEmail.length > 5 && (
                        <Card sx={{ borderRadius: 2, boxShadow: 3, bgcolor: '#f5f5f5', mt: 1 }}>
                          <CardContent>
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 2.5 }}>
                              <Typography variant="body1" sx={{ color: '#666', mt: 1.2, textAlign: 'center' }}>
                                No contacts found
                              </Typography>
                            </Box>
                          </CardContent>
                        </Card>
                      )}
                    </Box>
                  )}
                </Grid>
           

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Client First Name"
                value={newAppraisal.clientName}
                onChange={(e) => setNewAppraisal({ ...newAppraisal, clientName: e.target.value })}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Client Last Name"
                value={newAppraisal.clientLastName}
                onChange={(e) => setNewAppraisal({ ...newAppraisal, clientLastName: e.target.value })}
                required
              />
            </Grid>
            </>
          )}
          </Grid>
        </Box>
      </DialogContent>
      
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button 
          onClick={() => setOpenDialog(false)}
          size="large"
        >
          Cancel
        </Button>
        <Button 
          onClick={handleSaveAppraisal} 
          variant="contained" 
          size="large"
          sx={{ px: 4 }}
        >
          {selectedAppraisal ? 'Update' : 'Create'} Appraisal
        </Button>
      </DialogActions>
    </Dialog>
    </Box>
  );
};

export default AppraisalView;